<template>
  <main class="px-5 py-4">
    <b-card class="cardStyle" no-body>
      <view-all-requests-filters
        :requests="requests"
        @search="search"
        :loadingRequests="loadingRequests"
      />
      <children-requests-table
        :currentPage="currentPage"
        :loadingRequests="loadingRequests"
        :perPage="perPage"
        :requests="requests"
        class="mt-3"
      />
    </b-card>
    <view-all-requests-footer
      v-if="!loadingRequests && requests.length > 0"
      :currentPage.sync="currentPage"
      :perPage="perPage"
      :totalRows="totalRows"
    />
  </main>
</template>

<script>
  import { newStatusMap } from '../../../utility/CommonFunctions';
  import ChildrenRequestsTable from './ChildrenRequestsTable';
  import ViewAllRequestsFilters from './ViewAllRequestsFilters';
  import ViewAllRequestsFooter from './ViewAllRequestsFooter';

  export default {
    name: 'view-all-requests',
    components: {
      ChildrenRequestsTable,
      ViewAllRequestsFilters,
      ViewAllRequestsFooter,
    },
    props: {
      user: Object,
    },
    data() {
      return {
        participantEmail: window['Laravel']['user_email'],
        legacyTicket: window['Laravel']['feature_flags']['legacy-ticket'],
        loadingRequests: false,
        requests: [],
        totalRows: 0,
        perPage: 10,
        currentPage: 1,
      };
    },
    computed: {
      canSeeSiteTeamMembers() {
        this.hasOversightPermission = this.user.permissions.some(
          p => p.name === 'access enrollment oversight',
        );
        return this.hasOversightPermission && !this.user.exostarId;
      },
    },
    created() {
      let params = {
        view: 'childView',
        participant_email: this.canSeeSiteTeamMembers ? '' : window['Laravel']['user_email'],
      };
      if (!this.legacyTicket) {
        params['legacyTicket'] = this.legacyTicket;
      }
      this.getRequests(params);
    },
    methods: {
      newStatusMap,
      search(payload) {
        let params = {
          view: 'childView',
          participant_email: this.canSeeSiteTeamMembers ? '' : window['Laravel']['user_email'],
        };
        if (!this.legacyTicket) {
          params['legacyTicket'] = this.legacyTicket;
        }
        params['study_like'] = payload.study;
        params['site_number_like'] = payload.site;
        params['application_id'] = payload.application;
        params['requested_for'] = payload.requested_for;
        params['requestor_like'] = payload.requester;
        params['requeststatus'] = payload.status;
        if (payload.relatedRequests) {
          params['related_to_like'] = this.participantEmail;
        }
        this.getRequests(params);
      },
      async getRequests(params) {
        this.loadingRequests = true;
        try {
          this.requests = [];
          this.totalRows = 0;
          this.currentPage = 1;
          let response = await axios.get(`/api/get-access-requests`, { params: params });
          if (response.status !== 204) {
            this.requests = response.data['items'];
            this.requests.map(object => {
              for (let key in object) {
                if (object[key] == null) object[key] = '';
              }
              return object;
            });
            this.requests.forEach(req => {
              let statusMap = this.newStatusMap(req.status, req.pendingReason);
              req['statusMap'] = statusMap.toUpperCase();
            });
            this.totalRows = this.requests.length;
          }
        } catch (error) {
          console.error(error);
        }
        this.loadingRequests = false;
      },
    },
  };
</script>
